"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cofix = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const COFIX_ABI = require("../../abi/cofix.json");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const REWARDR_ECEIVER = '0x6F52A45c54518E5726DfD76d6472CE4F8Cd3dc06';
class Cofix extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            exchange: optimalRate.data.exchange,
            deadline: optimalRate.data.deadline,
        };
    }
    getNetworkFees(srcToken, destToken) {
        const fee = new bignumber_js_1.default(1e18).dividedBy(100); //0.01 ETH
        return (this.isETHAddress(srcToken) || this.isETHAddress(destToken))
            ? fee.toFixed(0)
            : fee.times(2).toFixed(0);
    }
    getFillMethod(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const contract = new this.web3Provider.eth.Contract(COFIX_ABI, data.exchange);
            const deadline = data.deadline || this.getDeadline();
            if (this.isETHAddress(srcToken)) {
                return contract.methods.swapExactETHForTokens(destToken, data.srcAmount, data.destAmount, this.augustus._address, REWARDR_ECEIVER, deadline).encodeABI();
            }
            else if (this.isETHAddress(destToken)) {
                return contract.methods.swapExactTokensForETH(srcToken, data.srcAmount, data.destAmount, this.augustus._address, REWARDR_ECEIVER, deadline).encodeABI();
            }
            else {
                return contract.methods.swapExactTokensForTokens(srcToken, destToken, data.srcAmount, data.destAmount, this.augustus._address, REWARDR_ECEIVER, deadline).encodeABI();
            }
        });
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const swapData = yield this.getFillMethod(srcToken, destToken, data);
            return this.swap(srcToken, destToken, data, swapData, data.exchange);
        });
    }
}
exports.Cofix = Cofix;
//# sourceMappingURL=cofix.js.map